import { tv } from 'tailwind-variants';

import { Bubble, Image, pluralize } from '@frontendmentorio/design-system-v2';

function getTitle(count, name, slug) {
  const wins = `${name} has won this badge ${pluralize(count, 'time')}`;

  switch (slug) {
    case 'beta':
      return `${name} has been a member since Frontend Mentor was in beta`;
    case 'motw-1':
      return `Mentor of the Week - 1st Place: ${wins}`;
    case 'motw-2':
      return `Mentor of the Week - 2nd Place: ${wins}`;
    case 'motw-3':
      return `Mentor of the Week - 3rd Place: ${wins}`;
    case 'motm-1':
      return `Mentor of the Month - 1st Place: ${wins}`;
    case 'motm-2':
      return `Mentor of the Month - 2nd Place: ${wins}`;
    case 'motm-3':
      return `Mentor of the Month - 3rd Place: ${wins}`;
    case 'moty-1':
      return `Mentor of the Year - 1st Place: ${wins}`;
    case 'moty-2':
      return `Mentor of the Year - 2nd Place: ${wins}`;
    case 'moty-3':
      return `Mentor of the Year - 3rd Place: ${wins}`;
  }
}

const styles = tv({
  base: ['aspect-square', 'relative', 'w-[5.5rem]'],
});

export default function Badge({ className, count, name, slug }) {
  const hasCount = count && slug !== 'beta';
  const title = name ? getTitle(count, name, slug) : '';

  return (
    <div className={styles({ class: className })}>
      <Image
        alt={title}
        fill
        sizes="12rem"
        src={`/static/images/badges/${slug}.webp`}
        title={title}
      />

      {hasCount && (
        <Bubble
          ariaHidden
          className="absolute-center-x bg-neutral-900 bottom-[6%] font-bold font-secondary text-[0.5rem] w-[14%]"
        >
          {count}
        </Bubble>
      )}
    </div>
  );
}
